import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './SocialProofListQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SocialProofListQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  socialProofClickReasonsKey: Types.ClickReasonsEnum;
}>;


export type SocialProofListQuery = (
  { __typename?: 'Query' }
  & { entityPageEX?: Types.Maybe<(
    { __typename?: 'EntityPage' }
    & Pick<Types.EntityPage, 'id'>
    & { userPageContext?: Types.Maybe<(
      { __typename?: 'EntityPageUserContext' }
      & { socialProof?: Types.Maybe<(
        { __typename?: 'EntityPageSocialProofConnection' }
        & { pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>
        ), edges: Array<Types.Maybe<(
          { __typename?: 'EntityPageSocialProofEdge' }
          & { node?: Types.Maybe<(
            { __typename?: 'EntityPageSocialProof' }
            & { xingId?: Types.Maybe<(
              { __typename?: 'XingId' }
              & Pick<Types.XingId, 'id' | 'pageName' | 'displayName' | 'gender'>
              & { profileImage?: Types.Maybe<Array<Types.Maybe<(
                { __typename?: 'ProfileImage' }
                & Pick<Types.ProfileImage, 'url'>
              )>>>, clickReasonProfileUrl?: Types.Maybe<(
                { __typename?: 'ClickReason' }
                & Pick<Types.ClickReason, 'profileUrl'>
              )>, userFlags?: Types.Maybe<(
                { __typename?: 'UserFlags' }
                & Pick<Types.UserFlags, 'displayFlag'>
              )>, occupations?: Types.Maybe<Array<Types.Maybe<(
                { __typename?: 'XingIdOccupation' }
                & Pick<Types.XingIdOccupation, 'headline' | 'subline'>
              )>>> }
            )> }
          )> }
        )>> }
      )> }
    )> }
  ) | (
    { __typename?: 'EntityPageError' }
    & Pick<Types.EntityPageError, 'errorType' | 'errorCode'>
  ) | { __typename?: 'EntityPageMoved' }> }
);



/**
 * __useSocialProofListQuery__
 *
 * To run a query within a React component, call `useSocialProofListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialProofListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialProofListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      socialProofClickReasonsKey: // value for 'socialProofClickReasonsKey'
 *   },
 * });
 */
export function useSocialProofListQuery(baseOptions: Apollo.QueryHookOptions<SocialProofListQuery, SocialProofListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialProofListQuery, SocialProofListQueryVariables>(Operations.SocialProofList, options);
      }
export function useSocialProofListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialProofListQuery, SocialProofListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialProofListQuery, SocialProofListQueryVariables>(Operations.SocialProofList, options);
        }
export type SocialProofListQueryHookResult = ReturnType<typeof useSocialProofListQuery>;
export type SocialProofListLazyQueryHookResult = ReturnType<typeof useSocialProofListLazyQuery>;
export type SocialProofListQueryResult = Apollo.QueryResult<SocialProofListQuery, SocialProofListQueryVariables>;